import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NavigationEnd, Router, RouterOutlet } from '@angular/router';
import { HeaderComponent } from './components/header/header.component';
import { FooterComponent } from './components/footer/footer.component';
import { AlertComponent } from './components/alert/alert.component';
import { LoaderComponent } from './components/loader/loader.component';
import { DialogComponent } from './components/dialog/dialog.component';
import { BreadcrumbComponent } from './components/breadcrumb/breadcrumb.component';
import { filter } from 'rxjs';
import { AuthService } from './services/auth/auth.service';
import { CookiesComponent } from './components/cookies/cookies.component';

declare let gtag: Function;

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [CommonModule, RouterOutlet, HeaderComponent, FooterComponent, AlertComponent, LoaderComponent, DialogComponent, BreadcrumbComponent, CookiesComponent],
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
  constructor(
    private router: Router,
    private authService: AuthService
  ) {
    this.router.events.pipe(
      filter(event => event instanceof NavigationEnd)
    ).subscribe(() => {
      window.scrollTo(0, 0); // Scroll al top al finalizar la navegación
      gtag('config', 'G-N2QNYJX7YV', {
        page_path: window.location.pathname,
      });
    });
    if (this.authService.isAuthenticated()) {
      this.authService.getUser().catch(() => {
        this.authService.logoutUser();
        this.router.navigate(['/login']);
      });
      this.authService.getAppliant();
    }
  }
}

